import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reactivateSchedule, type SchedulePreferencesPayload } from '@/features/accounts/api';

export function useReactivateSchedule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ scheduleId, preferences }: { scheduleId: number; preferences: SchedulePreferencesPayload }) =>
      reactivateSchedule(scheduleId, preferences),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['schedules'] }),
  });
}
